import { useDispatch } from 'react-redux';
import { AnyAction } from '@reduxjs/toolkit';
import { ThunkDispatch } from 'redux-thunk';

import { TStore } from '@lootboy/lib/types/store';

import { TCardFiltersSliceType } from '~/redux/slices/cardFilters';
import { locationName, TLocationSliceType } from '~/redux/slices/location';

export type TAppStore = TStore & {
  [locationName]: TLocationSliceType;
  cardFilters: TCardFiltersSliceType;
};

export const useAppDispatch = (): ThunkDispatch<TAppStore, never, AnyAction> =>
  useDispatch<ThunkDispatch<TAppStore, never, AnyAction>>();
